import React from 'react';

interface IProps {
  style?: any;
}

const CopyMenuIcon:React.FC<IProps> = (props: IProps) => {
  return (
    <svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.436 1.918v1.43H6.502a3.166 3.166 0 0 0-2.98 2.104c-.173.486-.173.933-.173 1.29v9.69H1.919a1.97 1.97 0 0 1-1.275-.485C.197 15.56 0 14.997 0 14.419V2.183c0-.3 0-.596.102-.882A1.951 1.951 0 0 1 1.941 0c.607-.002 1.215 0 1.822 0h10.752a1.943 1.943 0 0 1 1.921 1.917z" fill="#204078"/>
    <path d="M21 17.125V6.463a1.941 1.941 0 0 0-1.916-1.9c-.146-.002-.292 0-.435 0H8.329c-.607 0-1.214-.002-1.822 0-.83.003-1.56.518-1.839 1.3-.102.287-.102.583-.102.882v12.241c0 .578.197 1.142.644 1.528.357.311.802.481 1.276.486h12.379c.374 0 .729-.036 1.074-.202.67-.32 1.061-1.027 1.064-1.758 0-.637-.003-1.276-.003-1.915z" fill="#204078"/>
    </svg>
  )
}

export default CopyMenuIcon;